import * as React from 'react';
import Grid from "@mui/material/Grid";
import {useNavigate} from "react-router-dom";
import {useState} from "react";
import useRootHook from "../../hooks/useRoot";
import helpers from "../../helpers/common";
import NewsForm from "./NewsForm";
import news from "../../models/news";
import PageHeader from '../layout/PageHeader';
import SectionCard from '../layout/SectionCard';

export default function NewsAdd(props) {
    const {setShowLoader} = useRootHook()
    const navigate = useNavigate()
    const [errors, setErrors] = useState({});
    const [fields, setFields] = useState({enabled: true})

    const handleChange = (ev) => {
        const [, value, name] = helpers.getFormEventData(ev);

        setErrors({...errors, [name]: undefined});

        setFields((prevState) => {
            let newFields = {...prevState};
            if (name === 'enabled') {
                newFields[name] = ev.target.checked;
            } else {
                newFields[name] = value;
            }

            return newFields
        })
    }

    const handleBlur = (ev) => {
        const [, , name] = helpers.getFormEventData(ev)

        const newErrors = {...errors}
        const newFields = {...fields}

        // Валидация будет через methodValidator
        setErrors(newErrors)
    }

    const handleSubmit = (ev) => {
        ev.preventDefault()
        const validationErrors = news.methodValidator.add(fields)
        setErrors(validationErrors)

        if (Object.keys(validationErrors).length !== 0) return

        setShowLoader(true)
        news.add(fields)
            .then(() => {
                setShowLoader(false)
                navigate('/news')
            }).catch(() => setShowLoader(false))
    }

    return <React.Fragment>
        <Grid size={12}>
            <PageHeader title="Add news" breadcrumbs={[['Dashboard', '/'], ['News', '/news'], ['Add', '/news/add']]} />
        </Grid>
        <Grid size={12}>
            <SectionCard sx={{ display: 'flex', flexDirection: 'column' }}>
                <NewsForm fields={fields} errors={errors} handleChange={handleChange}
                           handleBlur={handleBlur} handleSubmit={handleSubmit} />
            </SectionCard>
        </Grid>
    </React.Fragment>
}

